﻿import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col, Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useToasts } from "react-toast-notifications";

import { FETCH_BALANCES_SUCCESS, INITIAL_BALANCES_REQUEST } from "@/redux/types/maintainers/balances.type";

import Head from "@/components/Content/Head";
import classes from "../maintainers.module.scss";

import api from "@/services/api.service";

import BasePagination from "@/components/Pagination/BasePagination";
import Fetching from "@/components/Fetching/Fetching";
import BasicConfirm from "@/components/Confirm/BasicConfirm";
import BalancesTableHead from "./BalancesTableHead";
import BalancesTableBody from "./BalancesTableBody";
import BalancesForm from "./BalancesForm/BalancesForm";
import { toast } from "@/services/Utils";

const Balances = () => {
	const dispatch = useDispatch();
	const { addToast } = useToasts();
	const navigate = useNavigate();

	const { search } = useSelector((state) => state.auth.filter);
	const { isFetching, quantity, last_page, from, to } = useSelector((state) => state.maintainers_balances);

	const [selected, setSelected] = useState("");
	const [paginate, setPaginate] = useState(10);
	const [page, setPage] = useState(1);
	const [order, setOrder] = useState("name_customer");
	const [orderType, setOrderType] = useState("asc");
	const [loaded, setLoaded] = useState(false);

	const [showDelete, setShowDelete] = useState(false);

	useEffect(() => {
		dispatch({ type: INITIAL_BALANCES_REQUEST });
		api.get("/admin/balances", {
			page,
			paginate,
			order,
			orderType,
			search,
		}).then((response) => {
			updateData(response);
		});
		// eslint-disable-next-line
	}, [search, order, orderType, paginate, page]);

	const updateData = (response) => {
		if (Object.prototype.hasOwnProperty.call(response, "balances")) {
			const { balances, customers, estates_parents, estates, status, version } = response;
			dispatch({
				type: FETCH_BALANCES_SUCCESS,
				payload: {
					balances: balances.data,
					last_page: balances.last_page,
					from: balances.from,
					to: balances.to,
					quantity: balances.total,
					customers: customers,
					estates_parents: estates_parents,
					estates: estates,
					status: status,
					version: version,
				},
			});
			setLoaded(true);
		} else {
			setLoaded(true);
		}
	};

	const handleDelete = (item) => {
		setSelected(item.balance_id);
		setShowDelete(true);
	};

	const confirmDelete = () => {
		setShowDelete(false);
		setPage(1);

		dispatch({ type: INITIAL_BALANCES_REQUEST });
		api.post("/admin/balances/delete", {
			page,
			selected,
			paginate,
			order,
			orderType,
			search,
		}).then((response) => {
			setSelected("");
			toast(addToast, "Balanza eliminada correctamente.", "success");
			updateData(response);
		});
	};

	const confirmSave = (form, modalFetching, afterSave) => {
		modalFetching(true);
		setPage(1);

		api.post("/admin/balances/save", {
			...form.form,
			page,
			paginate,
			order,
			orderType,
			search,
		}).then((response) => {
			if (Object.prototype.hasOwnProperty.call(response, "balances")) {
				updateData(response);
				modalFetching(false);
				afterSave();
			} else {
				modalFetching(false);
			}
		});
	};

	if (isFetching) {
		return <Fetching />;
	}

	return (
		<>
			<Head
				title="Balanzas"
				button={true}
				button_text={"Nueva Balanza"}
				action={() => navigate("/mantenedores/balanzas/crear")}
				back_url={"/mantenedores"}
			/>

			<Row className={` ${classes.main_row}`}>
				<Col md={12} className={classes.main_col}>
					<Row className={classes.table}>
						<div className={classes.table_div}>
							<Table className={classes.table_desktop}>
								<BalancesTableHead order={order} setOrder={setOrder} orderType={orderType} setOrderType={setOrderType} />

								<BalancesTableBody handleDelete={handleDelete} />
							</Table>
						</div>
					</Row>

					<BasePagination
						page={page}
						paginate={paginate}
						last_page={last_page}
						quantity={quantity}
						from={from}
						to={to}
						setPage={setPage}
						setPaginate={setPaginate}
					/>
				</Col>
			</Row>

			{loaded && (
				<>
					<BasicConfirm
						showConfirm={showDelete}
						setShowConfirm={setShowDelete}
						handleAction={confirmDelete}
						message={"¿Está seguro de que desea eliminar la balanza?"}
					/>

					<BalancesForm confirmSave={confirmSave} />
				</>
			)}
		</>
	);
};

export default Balances;
